import { render } from "./BackendOfficeSolutionSpecialist.vue?vue&type=template&id=bed7f038"
import script from "./BackendOfficeSolutionSpecialist.vue?vue&type=script&lang=js"
export * from "./BackendOfficeSolutionSpecialist.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__